"use strict";
// Manually curated list of semiconductor manufacturers and their aliases/websites.
// When adding a new entries, avoid common suffixes in the name field like Inc, Corp, or words like Electronics or Devices.
// There is helper functions for this list in https://github.com/buildwithflux/flux-app/blob/4c9e1ffb05fddf0940532dcc3d6210148a99375e/packages/core/src/part/manufacturer/manufacturerAliases.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.semiconductorManufacturerAliases = void 0;
exports.semiconductorManufacturerAliases = [
    {
        legalName: "Texas Instruments Inc.",
        name: "Texas Instruments",
        website: "https://www.ti.com/",
        match: ["Texas Instruments", "TI"],
    },
    {
        legalName: "TE Connectivity Corporation",
        name: "TE Connectivity",
        website: "https://www.te.com/",
        match: ["TE Connectivity", "TE"],
    },
    {
        legalName: "Renesas Electronics Corporation",
        name: "Renesas",
        website: "https://www.renesas.com/",
        match: ["Runesasu", "Renesas", "ルネサス", "エレクトロニクス株式会社"],
    },
    {
        legalName: "Torex Semiconductor Ltd.",
        name: "Torex",
        website: "https://www.torexsemi.com/",
        match: ["Torex", "特瑞仕"],
    },
    { legalName: "CTS Corporation", name: "CTS", website: "https://www.ctscorp.com/", match: ["CTS", "西迪斯"] },
    {
        legalName: "Seeed Technology Co.",
        name: "Seeed",
        website: "https://www.seeedstudio.com/",
        match: ["Seeed", "Seed"],
    },
    {
        legalName: "Analog Devices, Inc.",
        name: "Analog Devices",
        website: "https://www.analog.com/",
        match: ["Analog Devices", "Linear Technology", "Linear Technology Corporation"],
    },
    { legalName: "Intel Corporation", name: "Intel", website: "https://www.intel.com/", match: ["Intel"] },
    { legalName: "NVIDIA Corporation", name: "NVIDIA", website: "https://www.nvidia.com/", match: ["NVIDIA"] },
    { legalName: "Micron Technology, Inc.", name: "Micron", website: "https://www.micron.com/", match: ["Micron"] },
    {
        legalName: "Microchip Technology Inc.",
        name: "Microchip",
        website: "https://www.microchip.com/",
        match: ["Microchip", "Atmel"],
    },
    {
        legalName: "Skyworks Solutions, Inc.",
        name: "Skyworks",
        website: "https://www.skyworksinc.com/",
        match: ["Skyworks"],
    },
    {
        legalName: "Maxim Integrated Products, Inc.",
        name: "Maxim Integrated",
        website: "https://www.maximintegrated.com/",
        match: ["Maxim"],
    },
    { legalName: "Xilinx, Inc.", name: "Xilinx", website: "https://www.xilinx.com/", match: ["Xilinx"] },
    {
        legalName: "Advanced Micro Devices, Inc.",
        name: "AMD",
        website: "https://www.amd.com/",
        match: ["AMD", "Advanced Micro Devices"],
    },
    {
        legalName: "Taiwan Semiconductor Manufacturing Co., Ltd.",
        name: "TSMC",
        website: "https://www.tsmc.com/",
        match: ["Taiwan Semiconductor", "TSM"],
    },
    { legalName: "Qualcomm Inc.", name: "Qualcomm", website: "https://www.qualcomm.com/", match: ["Qualcomm", "QCOM"] },
    { legalName: "Broadcom Inc.", name: "Broadcom", website: "https://www.broadcom.com/", match: ["Broadcom", "AVGO"] },
    {
        legalName: "ASE Technology Holding Co., Ltd.",
        name: "ASE",
        website: "https://www.aseglobal.com/",
        match: ["ASE", "ASX", "艾普凌科"],
    },
    {
        legalName: "STMicroelectronics",
        name: "STMicroelectronics",
        website: "https://www.st.com/",
        match: ["STMicroelectronics", "STM", "ST", "意法半导体"],
    },
    { legalName: "NXP Semiconductors", name: "NXP", website: "https://www.nxp.com/", match: ["NXP", "NXPI"] },
    {
        legalName: "Samsung Electronics Co., Ltd.",
        name: "Samsung",
        website: "https://www.samsung.com/",
        match: ["Samsung"],
    },
    { legalName: "Toshiba Corporation", name: "Toshiba", website: "https://www.global.toshiba/", match: ["Toshiba"] },
    { legalName: "MediaTek Inc.", name: "MediaTek", website: "https://www.mediatek.com/", match: ["MediaTek"] },
    {
        legalName: "Infineon Technologies AG",
        name: "Infineon",
        website: "https://www.infineon.com/",
        match: ["Infineon"],
    },
    { legalName: "Sony Corporation", name: "Sony", website: "https://www.sony.com/", match: ["Sony"] },
    { legalName: "Arm Ltd.", name: "Arm", website: "https://www.arm.com/", match: ["Arm"] },
    {
        legalName: "ON Semiconductor",
        name: "ON Semiconductor",
        website: "https://www.onsemi.com/",
        match: ["ON Semiconductor", "OnSemi", "安森美"],
    },
    { legalName: "United Microelectronics Corporation", name: "UMC", website: "https://www.umc.com/", match: ["UMC"] },
    { legalName: "Fujitsu Ltd.", name: "Fujitsu", website: "https://www.fujitsu.com/", match: ["Fujitsu"] },
    { legalName: "Hitachi Ltd.", name: "Hitachi", website: "https://www.hitachi.com/", match: ["Hitachi"] },
    {
        legalName: "Panasonic Corporation",
        name: "Panasonic",
        website: "https://www.panasonic.com/",
        match: ["Panasonic"],
    },
    { legalName: "SFI Electronics Technology Inc.", name: "SFI", match: ["SFI"] },
    { legalName: "YAGEO Group", name: "Yageo", website: "https://www.yageo.com/", match: ["Yageo", "国巨"] },
    {
        legalName: "Seiko Epson Corporation",
        name: "Seiko Epson",
        website: "https://global.epson.com/",
        match: ["Epson", "Seiko", "爱普生"],
    },
    {
        legalName: "Cirrus Logic Inc.",
        name: "Cirrus Logic",
        website: "https://www.cirrus.com/",
        match: ["Cirrus", "凌云"],
    },
    {
        legalName: "Nisshinbo Holdings Inc.",
        name: "Nisshinbo",
        website: "https://www.nisshinbo.co.jp/",
        match: ["Ricoh", "理光"],
    },
    { legalName: "ABLIC Inc.", name: "ABLIC", website: "https://www.ablic.com/", match: ["ABLIC", "艾普凌科"] },
    { legalName: "Ai-Thinker", name: "Ai-Thinker", match: ["Ai-Thinker", "安信可"] },
    { legalName: "Aishi Group", name: "Aishi", match: ["Aishi", "艾华集团"] },
    {
        legalName: "Alps Alpine Co., Ltd.",
        name: "Alps Alpine",
        website: "https://www.alpsalpine.com/",
        match: ["Alps Alpine", "阿尔卑斯阿尔派"],
    },
    { legalName: "AnBon", name: "AnBon", match: ["AnBon", "安邦"] },
    { legalName: "Blue Rocket", name: "Blue Rocket", match: ["Blue Rocket", "蓝箭"] },
    {
        legalName: "Anhui ANUKI Technologies Co., Ltd.",
        name: "Anuki",
        website: "http://www.yuntatech.com/",
        match: ["Anuki", "安努奇"],
    },
    {
        legalName: "Born Group",
        name: "Born Semiconductor",
        website: "https://www.borngroup.com/",
        match: ["Born", "伯恩半导体"],
    },
    { legalName: "Bourns Inc.", name: "Bourns", website: "https://www.bourns.com/", match: ["Bourns"] },
    { legalName: "Chilisin Electronics Corp.", name: "Chilisin", match: ["Chilisin", "奇力新"] },
    { legalName: "CJ Electronics", name: "CJ Electronics", match: ["CJ", "江苏长电", "长晶"] },
    { legalName: "Ckmtv", name: "Ckmtv", match: ["CKMTW", "灿科盟"] },
    { legalName: "Cosmo Electronics Corporation", name: "Cosmo", match: ["Cosmo", "冠西"] },
    { legalName: "CRC Industries", name: "CRC", website: "https://www.crcindustries.com/", match: ["CRC", "创容"] },
    {
        legalName: "Cypress Semiconductor Corp.",
        name: "Cypress",
        website: "https://www.cypress.com/",
        match: ["Cypress", "赛普拉斯"],
    },
    {
        legalName: "Diodes Incorporated",
        name: "Diodes",
        website: "https://www.diodes.com/",
        match: ["Diodes Inc", "美台"],
    },
    { legalName: "DMBJ", name: "DMBJ", match: ["DMBJ", "振宝佳"] },
    { legalName: "ELNA Co., Ltd.", name: "ELNA", match: ["ELNA", "伊娜"] },
    { legalName: "Everlight Electronics Co., Ltd.", name: "Everlight", match: ["Everlight", "亿光"] },
    { legalName: "FeiHong Electronics", name: "FeiHong", match: ["FeiHong", "飞虹"] },
    { legalName: "FH Technology", name: "FH", match: ["FH", "风华"] },
    { legalName: "FOSAN", name: "FOSAN", match: ["FOSAN", "富信"] },
    { legalName: "Goertek", name: "Goertek", match: ["Goertek", "歌尔"] },
    { legalName: "Goodwork", name: "Goodwork", match: ["Goodwork", "固得沃克"] },
    { legalName: "Hongda Electronics", name: "Hongda", match: ["Hongda", "泓达"] },
    {
        legalName: "KYOCERA Corporation",
        name: "KYOCERA",
        website: "https://global.kyocera.com/",
        match: ["KYOCERA", "京瓷"],
    },
    { legalName: "Ever Ohms Technology Co., Ltd.", name: "Ever Ohms", match: ["Ever Ohms", "天二科技"] },
    { legalName: "Slkor", name: "Slkor", website: "https://www.slkoric.com/", match: ["Slkor", "萨科微"] },
    { legalName: "Sumida Group", name: "Sumida", website: "https://www.sumida.com/", match: ["Sumida", "胜美达"] },
    {
        legalName: "Mornsun Power Supply",
        name: "Mornsun",
        website: "https://www.mornsun-power.com/",
        match: ["MORNSUN", "金升阳"],
    },
    {
        legalName: "Taiyo Yuden Co., Ltd.",
        name: "Taiyo Yuden",
        website: "https://www.yuden.co.jp/",
        match: ["Taiyo Yuden", "太诱", "太陽誘電株式会社"],
    },
    {
        legalName: "Winbond Electronics",
        name: "Winbond",
        website: "https://www.winbond.com/",
        match: ["Winbond", "华邦"],
    },
    { legalName: "BAM", name: "BAM", website: "https://www.china-bam.com/", match: ["华星机电"] },
    { legalName: "HCTL", name: "HCTL", match: ["HCTL", "华灿天禄"] },
    { legalName: "Hele Electronics", name: "Hele", match: ["Hele", "台湾加高"] },
    { legalName: "JGHC", name: "JGHC", match: ["JGHC", "晶光华"] },
    { legalName: "JST Electronics", name: "JST", match: ["JST"] },
    { legalName: "Jingweida Technology", name: "JWD", match: ["JWD", "经纬达"] },
    { legalName: "JYJE", name: "JYJE", match: ["JYJE", "晶友嘉"] },
    { legalName: "Knscha", name: "Knscha", match: ["Knscha", "科尼盛"] },
    { legalName: "Lelon Electronics Corporation", name: "Lelon", match: ["Lelon", "立隆"] },
    { legalName: "Linekey", name: "Linekey", match: ["Linekey", "立凯电控"] },
    { legalName: "Littelfuse Inc.", name: "Littelfuse", match: ["Littelfuse", "IXYS", "美国力特"] },
    { legalName: "LRC Electronics", name: "LRC", match: ["LRC", "乐山无线电"] },
    { legalName: "Micro Commercial Components Corp.", name: "MCC", match: ["MCC", "美微科"] },
    { legalName: "MOSPEC Semiconductor Corp.", name: "MOSPEC", match: ["MOSPEC", "统懋"] },
    { legalName: "Murata Manufacturing Co., Ltd.", name: "Murata", match: ["Murata", "村田"] },
    { legalName: "Nichicon Corporation", name: "Nichicon", match: ["Nichicon", "尼吉康"] },
    { legalName: "Pingwei Electronics", name: "Pingwei", match: ["Pingwei", "平伟"] },
    { legalName: "PTTC", name: "PTTC", match: ["PTTC", "聚鼎"] },
    { legalName: "Ralec", name: "Ralec", match: ["Ralec", "旺诠"] },
    { legalName: "Raltron Electronics Corporation", name: "Raltron", match: ["Raltron", "美国纬创电子"] },
    { legalName: "Rayson", name: "Rayson", match: ["Rayson", "晶存"] },
    { legalName: "RichWave", name: "RichWave", match: ["RichWave", "立积"] },
    { legalName: "Ricky Electronics", name: "Ricky", match: ["Ricky"] },
    { legalName: "Rohm Co., Ltd.", name: "Rohm", match: ["Rohm", "罗姆"] },
    { legalName: "Rongqiang Electronics ", name: "Roqang", match: ["ROQANG", "容强"] },
    { legalName: "Ruichips", name: "Ruichips", match: ["Ruichips", "锐骏半导体"] },
    { legalName: "RUNIC Technology", name: "RUNIC", match: ["RUNIC", "润石"] },
    { legalName: "RYCHiP", name: "RYCHiP", match: ["RYCHiP", "蕊源"] },
    { legalName: "RZ Microelectronics", name: "RZ", match: ["RZ", "睿智微"] },
    { legalName: "Nanjing Sart Tech", name: "SART", match: ["SART", "萨特"] },
    { legalName: "SCTF Electronics Co., Ltd", name: "SCTF", match: ["SCTF", "星通时频"] },
    { legalName: "Stackpole Electronics Inc.", name: "SEI", match: ["SEI", "Stackpole Electronics Inc."] },
    { legalName: "Sembo Electronics Co., Ltd.", name: "SEMBO", match: ["SEMBO", "深波"] },
    { legalName: "Semtech Corporation", name: "Semtech", match: ["Semtech"] },
    { legalName: "Silan Microelectronics", name: "Silan", match: ["Silan", "士兰微"] },
    { legalName: "Brightking", name: "Brightking", match: ["Brightking", "君耀电子"] },
    { legalName: "C&K Switches", name: "C&K", website: "http://www.ckswitches.com/", match: ["C&K"] },
    { legalName: "CJ Electronics", name: "CJ", match: ["CJ", "江苏长电", "长晶"] },
    { legalName: "SFI Electronics Technology Inc.", name: "SFI", match: ["SFI"] },
    { legalName: "Sunlord", name: "Sunlord", match: ["Sunlord", "顺络"] },
    { legalName: "OSRAM Licht AG", name: "OSRAM", website: "https://ams-osram.com/", match: ["OSRAM", "欧司朗"] },
    { legalName: "Yanchuang", name: "Yanchuang", match: ["Yanchuang", "研创"] },
    { legalName: "Yangzhou Yangjie Electronic Technology Co., Ltd.", name: "YANGJIE", match: ["YANGJIE", "扬杰"] },
    {
        legalName: "Shandong Jingdao Micro-Electrons Co.,Ltd.",
        name: "Jingdao",
        match: ["Shandong", "Jingdao", "晶导微电子"],
    },
    { legalName: "3L COILS", name: "3L COILS", match: ["3L COILS", "三礼"] },
    { legalName: "BNstar", name: "BNstar", match: ["BNstar", "比诺星"] },
    { legalName: "CEC Electronics", name: "CEC", match: ["CEC", "振华"] },
    { legalName: "Champion Electronics", name: "Champion", match: ["Champion", "全鹏"] },
    { legalName: "Coilmaster", name: "CEC Electronics", match: ["Coilmaster", "统宇电研"] },
    { legalName: "Comchip", name: "Comchip", match: ["Comchip", "典琦"] },
    { legalName: "DIYI Electronic Technology Co., Ltd.", name: "DIYI", match: ["DIYI", "迪一", "芯诺"] },
    { legalName: "Hangzhou Dongwo Electronic Technology Co., Ltd.", name: "DOWO", match: ["DOWO", "东沃"] },
    { legalName: "FG-ELEKTRONIK GmbH", name: "FG", website: "https://www.fg-elektronik.com/", match: ["FG", "富港"] },
    { legalName: "FMS Technology", name: "FMS", website: "https://www.fms-technology.com/", match: ["FMS", "美丽微"] },
    { legalName: "G-Switch", name: "G-Switch", match: ["G-Switch", "品赞"] },
    { legalName: "Huake Semiconductor Co., LTD.", name: "Huake", match: ["Huake", "华科"] },
    { legalName: "Infineon Technologies AG", name: "Infineon", website: "https://www.infineon.com", match: ["Infineon"] },
    { legalName: "JGHC", name: "JGHC", match: ["JGHC", "晶光华"] },
    { legalName: "Kodenshi AUK", name: "KODENSHI", match: ["KODENSHI", "光电子"] },
    { legalName: "MaxLinear", name: "MaxLinear", match: ["MaxLinear", "迈凌"] },
    { legalName: "Maplesemi", name: "Maplesemi", match: ["Maplesemi", "美浦森"] },
    { legalName: "NIDEC Corporation", name: "NIDEC", match: ["NIDEC", "尼得科"] },
    { legalName: "Risheng", name: "RISHENG", match: ["RISHENG", "日昇"] },
    { legalName: "SMC", name: "SMC", match: ["SMC", "桑德斯"] },
    { legalName: "SIT", name: "SIT", match: ["SIT", "芯力特"] },
    { legalName: "SM Switch", name: "SM Switch", match: ["SM Switch"] },
    { legalName: "SOFNG", name: "SOFNG", match: ["SOFNG", "硕方"] },
    { legalName: "Sonix", name: "Sonix", match: ["Sonix", "松翰"] },
    { legalName: "Sorede Electronic Co., Ltd.", name: "Sorede", match: ["Sorede", "索瑞达"] },
    { legalName: "Spansion", name: "Spansion", match: ["Spansion", "飞索"] },
    { legalName: "SPS", name: "SPS", match: ["SPS", "美国源芯"] },
    { legalName: "Stanson Technology", name: "Stanson", match: ["Stanson", "司坦森"] },
    { legalName: "STC", name: "STC", match: ["STC", "宏晶"] },
    { legalName: "Sunlight", name: "Sunlight", match: ["Sunlight", "光华"] },
    { legalName: "Suntek", name: "Suntek", match: ["Suntek", "洺太电子"] },
    { legalName: "SCTF", name: "SCTF", match: ["SCTF", "星通时频"] },
    { legalName: "TDK Corporation", name: "TDK", match: ["TDK"] },
    { legalName: "TKS", name: "TKS", match: ["TKS", "兴勤"] },
    { legalName: "UMW", name: "UMW", match: ["UMW", "友台半导体"] },
    { legalName: "VBsemi", name: "VBsemi", match: ["VBsemi", "微碧半导体"] },
    { legalName: "Vishay", name: "Vishay", match: ["Vishay", "威世"] },
    { legalName: "Walsin", name: "Walsin", match: ["Walsin", "华新科"] },
    {
        legalName: "Suzhou Walter Electronic Co., Ltd.",
        name: "Walter",
        website: "https://walterfuse.com/",
        match: ["Walter", "华德"],
    },
    {
        legalName: "WINDAY Electronic Dongguan Company Limited",
        name: "WINDAY",
        website: "http://www.winday.com.tw/",
        match: ["WINDAY", "威迪"],
    },
    { legalName: "Xunpu", name: "Xunpu", match: ["XUNPU", "讯普"] },
    { legalName: "YFW", name: "YFW", match: ["YFW", "佑风微"] },
    { legalName: "Yunxing", name: "Yunxing", match: ["Yunxing", "云星"] },
    { legalName: "Shanghai Chaozhi", name: "Chaozhi", match: ["上海超致"] },
    { legalName: "Song Le", name: "Song Le", match: ["Song Le", "松乐"] },
    { legalName: "Silicon Labs", name: "Silicon Labs", match: ["芯科"] },
    { legalName: "Knowles Electronics, LLC.", name: "Knowles", match: ["Knowles", "楼氏"] },
    { legalName: "CCTC", name: "CCTC", match: ["三环", "China Circuit Technology Corporation"] },
    { legalName: "YJYCOIN", name: "YJYCOIN", match: ["益嘉源"] },
    { legalName: "BZCN", name: "BZCN", match: ["博众电气"] },
    { legalName: "Tech Public Electronics", name: "FILL IN", match: ["台舟", "Tech Public"] },
    { legalName: "Shun Xiang Connaught Electronics Co., Ltd.", name: "FILL IN", match: ["顺翔诺", "SXN"] },
    { legalName: "Shanghai Yongming Electronic Co., Ltd.", name: "Ymin", match: ["Ymin", "永铭"] },
    { legalName: "Central Electronics", name: "Central", match: ["Central", "中环"] },
    { legalName: "Shenzhen Shouhan Technology Co., Ltd.", name: "Shou Han", match: ["SHOU HAN", "首韩"] },
    { legalName: "Xinluda Information Technology Co., Ltd", name: "Xinluda", match: ["Xinluda", "信路达"] },
    { legalName: "CCO (Chian Chia Elec)", name: "CCO", match: ["CCO", "千志电子"] },
    { legalName: "Hongyuan Precision", name: "HYP", match: ["HYP", "鸿源精密"] },
    { legalName: "Yi Yuan Electronics Co., Ltd.", name: "Yi Yuan", match: ["YIYUAN", "Yi Yuan", "怡远"] },
    { legalName: "HRO Switch & Jack", name: "HRO", match: ["HRO", "韩国韩荣"] },
    {
        legalName: "TongJia Optoelectronics Technology Co., Ltd.",
        name: "Togialed",
        website: "https:///www.togialed.com",
        match: ["Togialed", "TongJia", "统佳"],
    },
    { legalName: "DEALON Precision Industry Co., Ltd.", name: "Dealon", match: ["DEALON", "德艺隆"] },
    { legalName: "Viiyong", name: "Viiyong", match: ["微容"] },
    { legalName: "NX Electronics Limited", name: "Nextron", match: ["Nextron", "正凌"] },
    { legalName: "Anaren", name: "Anaren", match: ["Anaren", "安伦"] },
    { legalName: "Johanson Technology Inc.", name: "Johanson", match: ["Johanson", "约翰逊"] },
    { legalName: "EMTEK", name: "EMTEK", match: ["EMTEK", "兆欣"] },
    { legalName: "Macom", name: "Macom", match: ["Macom"] },
    { legalName: "ADI", name: "ADI", match: ["ADI", "亚德诺"] },
    { legalName: "Ohmite", name: "Ohmite", match: ["Ohmite"] },
    { legalName: "RESI", name: "RESI", match: ["RESI", "开步睿思"] },
    { legalName: "SHIKUES", name: "Shikues", match: ["SHIKUES", "时科"] },
    { legalName: "ISSI", name: "ISSI", match: ["ISSI", "美国芯成"] },
    { legalName: "LIZ", name: "LIZ", match: ["LIZ", "丽智电子"] },
    { legalName: "TA-I Technology", name: "TA-I", match: ["TA-I", "大毅科技"] },
    { legalName: "Kinghelm", name: "Kinghelm", match: ["Kinghelm", "金航标"] },
    { legalName: "Fojan", name: "Fojan", match: ["Fojan", "富捷"] },
    { legalName: "HKR", name: "HKR", match: ["HKR", "香港电阻"] },
    { legalName: "SRD", name: "SRD", match: ["SRD", "圣融达"] },
    { legalName: "ADI Electronics", name: "ADI", website: "http://www.adielectronics.com/", match: ["ADI", "亚德诺"] },
    {
        legalName: "Kunshan Housheng Electronic Industry Co., Ltd.",
        name: "UNI-ROYAL",
        website: "http://www.uni-royal.cn/",
        match: ["UNI-ROYAL", "厚声"],
    },
    {
        legalName: "Microsemi Corporation",
        name: "Microsemi",
        website: "https://www.microsemi.com/",
        match: ["Microsemi", "美高森美"],
    },
    {
        legalName: "Rubycon Corporation",
        name: "Rubycon",
        website: "https://www.rubycon.co.jp/",
        match: ["rubycon", "红宝石"],
    },
    {
        legalName: "KEMET Corporation",
        name: "KEMET",
        website: "https://www.kemet.com/",
        match: ["KEMET", "基美"],
    },
    {
        legalName: "Anhui VICO",
        name: "VO",
        match: ["VO", "翔胜"],
    },
    {
        legalName: "Viking Electronics",
        name: "Viking",
        website: "https://vikingelectronics.com/",
        match: ["Viking", "光颉"],
    },
    {
        legalName: "PANJIT Electronics",
        name: "PANJIT",
        website: "https://www.panjit.com.tw/",
        match: ["PANJIT", "强茂"],
    },
    {
        legalName: "Guangdong Shikues Micro Industrial Co., ltd",
        name: "Shikues",
        website: "https://www.shikues.com/",
        match: ["Shikues", "时科"],
    },
    {
        legalName: "LIZ Electronics (Kunshan) Co., Ltd",
        name: "LIZ",
        website: "https://www.lizgroup.com/",
        match: ["LIZ", "丽智电子"],
    },
    {
        legalName: "Tai-Tech Advanced Electronics Co., Ltd",
        name: "Tai-Tech",
        website: "https://en.tai-tech.com.tw/",
        match: ["Tai-Tech", "台庆"],
    },
    {
        legalName: "Sunltech",
        name: "Sunltech",
        website: "http://www.sunltech.com/",
        match: ["Sunltech", "韩国顺磁"],
    },
    {
        legalName: "Yuandi",
        name: "Yuandi",
        website: "http://www.yuandicn.com/",
        match: ["Yuandi", "元迪"],
    },
    {
        legalName: "PROD Electronic Technology (Shenzhen) Co., Ltd.",
        name: "PROD",
        website: "https://www.prodtech.cn/",
        match: ["PROD", "谱罗德"],
    },
    {
        legalName: "Wcon Electronics (Guangdong) Co., Ltd.",
        name: "Wcon",
        website: "https://www.wcon.com/",
        match: ["Wcon", "维峰电子"],
    },
    {
        legalName: "Integrated Silicon Solution Inc.",
        name: "ISSI",
        website: "https://www.issi.com/",
        match: ["ISSI", "美国芯成"],
    },
    {
        legalName: "JS Electronic",
        name: "JS",
        website: "http://www.jselectronic.com/",
        match: ["JS", "钜硕电子"],
    },
    {
        legalName: "Shanghai Hirose Electric Co., Ltd.",
        name: "HRS",
        match: ["HRS", "广濑"],
    },
    {
        legalName: "Shenzhen Liown Electronics Co. Ltd",
        name: "Liown",
        match: ["Liown", "里阳半导体"],
    },
    {
        legalName: "TAIC Electronics Co., Ltd.",
        name: "Tech Public",
        website: "https://www.techpublic.com.tw/",
        match: ["Tech Public", "台舟"],
    },
    {
        legalName: "Nexperia Global Semiconductor Company",
        name: "Nexperia",
        website: "https://www.nexperia.com/",
        match: ["Nexperia", "安世"],
    },
    {
        legalName: "Kefa Electronics Co., Ltd.",
        name: "Kefa",
        website: "https://www.kefaelectronic.com/",
        match: ["Kefa", "科发"],
    },
    {
        legalName: "Omron Electronic Components",
        name: "Omron",
        website: "https://www.omron.com/",
        match: ["Omron", "幸亚电阻"],
    },
    {
        legalName: "Tyohm Electronics Works Co., Ltd.",
        name: "Tyohm",
        website: "https://www.tyohm.com.tw/",
        match: ["Tyohm", "幸亚电阻"],
    },
    {
        legalName: "HR Electronic",
        name: "HR",
        website: "https://www.hrelectronic.com/",
        match: ["HR", "灿达"],
    },
    {
        legalName: "XFCN Electronics",
        name: "XFCN",
        match: ["XFCN", "兴飞"],
    },
    {
        legalName: "PSA",
        name: "PSA",
        match: ["PSA", "信昌电陶"],
    },
    {
        legalName: "Ningbo Dorabo Electric Co., Ltd.",
        name: "Dorabo",
        website: "https://www.nbdibo.com/",
        match: ["Dorabo", "地博电气"],
    },
    {
        legalName: "Kyocera",
        name: "Kyocera",
        website: "https://global.kyocera.com/",
        match: ["Kyocera"],
    },
    {
        legalName: "Abracon",
        name: "Abracon",
        match: ["Abracon"],
    },
    {
        legalName: "Mean Well USA Inc.",
        name: "Mean Well",
        website: "https://www.meanwell.com/",
        match: ["Mean Well"],
    },
    {
        legalName: "SHM",
        name: "SHM",
        match: ["SHM", "南方宏明"],
    },
    {
        legalName: "Shenzhen Eyang Tech Development",
        name: "Eyang",
        match: ["eyang", "宇阳科技"],
    },
    {
        legalName: "YXC",
        name: "YXC",
        match: ["YXC", "扬兴晶振"],
    },
    {
        legalName: "Arduino AG",
        name: "Arduino",
        website: "https://www.arduino.cc/",
        match: ["Arduino"],
    },
    {
        legalName: "Espressif Systems",
        name: "Espressif",
        website: "https://www.espressif.com/",
        match: ["Espressif"],
    },
    {
        legalName: "Würth Elektronik",
        name: "Würth",
        website: "https://www.we-online.com/",
        match: ["würth", "wurth"],
    },
    {
        legalName: "Venkel Ltd.",
        name: "Venkel",
        website: "https://www.venkel.com/",
        match: ["venkel"],
    },
    {
        legalName: "Molex, LLC",
        name: "Molex",
        website: "https://www.molex.com/",
        match: ["molex"],
    },
    {
        legalName: "Samtec Inc.",
        name: "Molex",
        website: "https://www.molex.com/",
        match: ["molex"],
    },
    {
        legalName: "Memory Protection Devices Corporation",
        name: "MPD",
        website: "https://www.memoryprotectiondevices.com/",
        match: ["mpd", "memory protection devices"],
    },
    {
        legalName: "Raspberry Pi Ltd.",
        name: "Raspberry Pi",
        website: "https://www.raspberrypi.com/",
        match: ["Raspberry"],
    },
    {
        legalName: "Socle Technology Corporation",
        name: "Socle",
        website: "https://www.socle-tech.com/",
        match: ["Socle"],
    },
    {
        legalName: "Kingbright Electronic Co., Ltd.",
        name: "Kingbright",
        website: "https://www.kingbright.com",
        match: ["Kingbright"],
    },
    {
        legalName: "Ningbo Songle relay Co., Ltd",
        name: "Ningbo",
        website: "http://www.songlerelay.cn",
        match: ["Ningbo"],
    },
    {
        legalName: "Lite-On Inc.",
        name: "Lite-On",
        website: "http://www.liteon.com",
        match: ["Lite-On"],
    },
    {
        legalName: "SparkFun Electronics",
        name: "SparkFun",
        website: "https://www.sparkfun.com/",
        match: ["Spark Fun"],
    },
    {
        legalName: "Adafruit Industries",
        name: "Adafruit",
        website: "https://www.adafruit.com/",
        match: ["Adafruit"],
    },
    {
        legalName: "Fairchild Semiconductor",
        name: "Fairchild",
        website: "https://www.fairchildsemi.com/",
        match: ["Fairchild"],
    },
    {
        legalName: "Sharp Corporation",
        name: "Sharp",
        website: "https://www.sharp.com/",
        match: ["Sharp"],
    },
    {
        legalName: "Keystone Electronics",
        name: "Keystone",
        website: "https://www.keyelco.com/",
        match: ["Keystone"],
    },
    {
        legalName: "Multicomp Electronics",
        name: "Multicomp",
        website: "https://multicomp-pro.com/",
        match: ["Multicomp"],
    },
    {
        legalName: "E-Switch, Inc.",
        name: "E-Switch",
        website: "https://www.e-switch.com/",
        match: ["E-Switch"],
    },
    {
        legalName: "Laird Performance Materials",
        name: "Laird",
        website: "https://www.laird.com/",
        match: ["laird"],
    },
    {
        legalName: "AMS Technologies",
        name: "AMS",
        website: "https://www.amstechnologies-webshop.com/",
        match: ["AMS"],
    },
    {
        legalName: "Samtec Inc.",
        name: "Samtec",
        website: "https://www.samtec.com/",
        match: ["Samtec"],
    },
    {
        legalName: "Stackpole Electronics, Inc",
        name: "Stackpole",
        website: "https://www.seielect.com/",
        match: ["Stackpole"],
    },
    {
        legalName: "Korean Hroparts Elec",
        name: "Hroparts",
        match: ["Hroparts"],
    },
    {
        legalName: "Shaanxi Dibo Shengzhuo Electronics Technology Co., Ltd.",
        name: "Dibo",
        match: ["Dibo"],
    },
    {
        legalName: "Phoenix Contact Development and Manufacturing, Inc.",
        name: "Phoenix Contact",
        website: "https://www.phoenixcontact.com/",
        match: ["Phoenix"],
    },
    {
        legalName: "Kexin Electronic Industrial Ltd.",
        name: "Kexin",
        website: "https://www.kexindg.com/",
        match: ["Kexin"],
    },
    {
        legalName: "Luguang Electronic Technology Co.,Ltd.",
        name: "LGE",
        website: "https://www.lgesemi.com/",
        match: ["LGE"],
    },
    {
        legalName: "Dialight",
        name: "Dialight",
        website: "https://www.dialight.com/",
        match: ["dialight"],
    },
];
//# sourceMappingURL=semiconductorManufacturerAliases.js.map